import { render, staticRenderFns } from "./ShopHistoryBox.vue?vue&type=template&id=18aa6c92&"
import script from "./ShopHistoryBox.vue?vue&type=script&lang=js&"
export * from "./ShopHistoryBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports